"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeriesVtab = void 0;
/*const seriesVfs: sqlite3_module = {
  iVersion: 0,
  xConnect()
}
*/
const SQLITE_OK = 0;
const SQLITE_MISUSE = 21;
var Columns;
(function (Columns) {
    Columns[Columns["idx"] = 0] = "idx";
    Columns[Columns["id"] = 1] = "id";
    Columns[Columns["tagName"] = 2] = "tagName";
    Columns[Columns["textContent"] = 3] = "textContent";
    Columns[Columns["innerHTML"] = 4] = "innerHTML";
    Columns[Columns["outerHTML"] = 5] = "outerHTML";
    Columns[Columns["className"] = 6] = "className";
    Columns[Columns["parent"] = 7] = "parent";
    Columns[Columns["selector"] = 8] = "selector";
    Columns[Columns["querySelector"] = 9] = "querySelector";
})(Columns || (Columns = {}));
const columnNames = Object.keys(Columns)
    .map((key) => Columns[key])
    .filter((value) => typeof value === "string");
function rowToObject(row) {
    const out = {};
    for (let i = 0; i < row.length; i++) {
        out[Columns[i]] = row[i];
    }
    return out;
}
// sends a request to the main thread via postMessage,
// then synchronously waits for the result via a SharedArrayBuffer
function doAsyncRequestToMainThread(request) {
    // todo: dynamically adjust this for response size
    const sab = new SharedArrayBuffer(1024 * 1024);
    // first element is for atomic synchronisation, second element is the length of the response
    const metaArray = new Int32Array(sab, 0, 2);
    metaArray[0] = 1;
    // send message to main thread
    self.postMessage({
        action: "eval",
        notify: sab,
        request,
    });
    Atomics.wait(metaArray, 0, 1); // wait until first element is not =1
    const dataLength = metaArray[1];
    // needs to be copied because textdecoder and encoder is not supported on sharedarraybuffers (for now)
    const dataArray = new Uint8Array(sab, 2 * 4, dataLength).slice();
    const resStr = new TextDecoder().decode(dataArray);
    const res = JSON.parse(resStr);
    if ("err" in res)
        throw new Error(res.err);
    return res.ok;
}
class SeriesVtab {
    constructor(module, db) {
        this.module = module;
        this.db = db;
        this.name = "dom";
        this.iVersion = 2;
        this.cursors = new Map();
        console.log("constructed vfs");
    }
    getCursor(cursor) {
        const cursorObj = this.cursors.get(cursor);
        if (!cursorObj)
            throw Error("impl error");
        return cursorObj;
    }
    xConnect(conn, pAux, argc, argv, ppVTab, pzErr) {
        console.log("xconnect!!");
        const rc = this.db.handleError(this.module.ccall("sqlite3_declare_vtab", "number", ["number", "string"], [
            conn,
            `create table x(
              ${columnNames.slice(0, -1).join(", ")} PRIMARY KEY
          ) WITHOUT ROWID`,
        ]));
        const out_ptr = this.module._malloc(12);
        this.module.setValue(ppVTab, out_ptr, "*");
        return SQLITE_OK;
    }
    xDisconnect(pVTab) {
        this.module._free(pVTab);
        return SQLITE_OK;
    }
    xOpen(pVTab, ppCursor) {
        const cursor = this.module._malloc(4);
        // this.module.setValue(series_cursor + 4, cursorId, "i32");
        this.cursors.set(cursor, { elements: [], index: 0, querySelector: "" });
        this.module.setValue(ppCursor, cursor, "*");
        return SQLITE_OK;
    }
    xClose(sqlite3_vtab_cursor) {
        this.module._free(sqlite3_vtab_cursor);
        return SQLITE_OK;
    }
    /*setErrorMessage(cursorPtr: Ptr<sqlite3_vtab_cursor>) {
      const vtabPointer: Ptr<sqlite3_vtab> = this.module.getValue(cursorPtr, "i32");
      const before = this.module.getValue(vtabPointer + 8, "i32");
      console.log("err before", before);
      this.module.setValue(vtabPointer + 8, intArrayFromString("FLONKITAL"), "i32");
    }*/
    xBestIndex(pVTab, info) {
        try {
            const nConstraint = this.module.getValue(info + 0, "i32");
            const aConstraint = this.module.getValue(info + 4, "i32");
            // const constraint = this.module.getValue(aConstraint, "i32");
            // don't care
            const SQLITE_INDEX_CONSTRAINT_MATCH = 64;
            let haveSelectorMatchConstraint = false;
            for (let i = 0; i < nConstraint; i++) {
                const sizeofconstraint = 12;
                const curConstraint = aConstraint + i * sizeofconstraint;
                const iColumn = this.module.getValue(curConstraint, "i32");
                const op = this.module.getValue(curConstraint + 4, "i8");
                const usable = this.module.getValue(curConstraint + 5, "i8");
                if (!usable)
                    continue;
                if (op === SQLITE_INDEX_CONSTRAINT_MATCH) {
                    if (iColumn === Columns.selector) {
                        // this is the one
                        haveSelectorMatchConstraint = true;
                        const aConstraintUsage = this.module.getValue(info + 4 * 4, "i32");
                        const sizeofconstraintusage = 8;
                        this.module.setValue(aConstraintUsage + i * sizeofconstraintusage, 1, "i32");
                    }
                    else {
                        throw Error(`The match operator can only be applied to the selector column!`);
                    }
                }
                console.log(`constraint ${i}: ${Columns[iColumn]} (op=${op})`);
            }
            if (!haveSelectorMatchConstraint) {
                throw Error("You must query the dom using `select ... from dom where selector MATCH <css-selector>`");
            }
            // const aConstraintUsage0 = this.module.getValue(aConstraintUsageArr, "i32");
            const usedColumnsFlag = this.module.getValue(info + 16 * 4, "i32");
            this.module.setValue(info + 5 * 4, usedColumnsFlag, "i32"); // just save the used columns instead of an index id
            return SQLITE_OK;
        }
        catch (e) {
            console.error("xbestindex", e);
            this.setVtabError(pVTab, String(e));
            return SQLITE_MISUSE;
        }
    }
    xFilter(cursorPtr, idxNum, idxStr, argc, argv) {
        console.log("xfilter", argc);
        if (argc !== 1) {
            console.error("did not get a single argument to xFilter");
            return SQLITE_MISUSE;
        }
        const querySelector = this.module.extract_value(argv + 0);
        const cursor = this.getCursor(cursorPtr);
        // await new Promise(e => setTimeout(e, 1000));
        cursor.querySelector = querySelector;
        const usedColumnsFlag = idxNum;
        const usedColumns = columnNames.filter((c) => usedColumnsFlag & (1 << Columns[c]));
        console.log("used columns", usedColumns);
        cursor.elements = doAsyncRequestToMainThread({
            type: "select",
            selector: querySelector,
            columns: usedColumns,
        }); // document.querySelectorAll(str);
        // don't filter anything
        return SQLITE_OK;
    }
    xNext(cursorPtr) {
        const cursor = this.getCursor(cursorPtr);
        cursor.index++;
        return SQLITE_OK;
    }
    xEof(cursorPtr) {
        const cursor = this.getCursor(cursorPtr);
        return +(cursor.index >= cursor.elements.length);
    }
    xColumn(cursorPtr, ctx, column) {
        const cursor = this.getCursor(cursorPtr);
        const ele = cursor.elements[cursor.index];
        if (Columns[column] in ele) {
            this.module.set_return_value(ctx, ele[Columns[column]]);
        }
        else {
            switch (column) {
                case Columns.idx: {
                    this.module.set_return_value(ctx, cursor.index);
                    break;
                }
                case Columns.querySelector: {
                    this.module.set_return_value(ctx, cursor.querySelector);
                    break;
                }
                default: {
                    throw Error(`unknown column ${Columns[column]}`);
                }
            }
        }
        return SQLITE_OK;
    }
    setVtabError(vtab, err) {
        const len = this.module.lengthBytesUTF8(err) + 1;
        const ptr = this.module.sqlite3_malloc(len);
        console.log("writing error", err, len);
        this.module.stringToUTF8(err, ptr, len);
        this.module.setValue(vtab + 8, ptr, "i32");
    }
    xUpdate(vtab, argc, argv, pRowid) {
        try {
            // https://www.sqlite.org/vtab.html#xupdate
            const [oldPrimaryKey, newPrimaryKey, ...args] = Array.from({ length: argc }, (_, i) => this.module.extract_value(argv + 4 * i));
            if (!oldPrimaryKey) {
                console.assert(newPrimaryKey === null);
                // INSERT
                doAsyncRequestToMainThread({
                    type: "insert",
                    value: rowToObject(args),
                });
            }
            else if (oldPrimaryKey && !newPrimaryKey) {
                console.log("DELETE", oldPrimaryKey);
                doAsyncRequestToMainThread({
                    type: "delete",
                    selector: oldPrimaryKey,
                });
                // DELETE
            }
            else {
                // UPDATE
                if (oldPrimaryKey !== newPrimaryKey) {
                    throw "The selector row can't be set";
                }
                doAsyncRequestToMainThread({
                    type: "update",
                    value: rowToObject(args),
                });
            }
            return SQLITE_OK;
        }
        catch (e) {
            this.setVtabError(vtab, String(e));
            return SQLITE_MISUSE;
        }
    }
    xRowid(sqlite3_vtab_cursor, pRowid) {
        throw Error("xRowid not implemented");
    }
    xFindFunction(pVtab, nArg, zName, pxFunc, ppArg) {
        const name = this.module.UTF8ToString(zName);
        if (name !== "match") {
            return SQLITE_OK;
        }
        const SQLITE_INDEX_CONSTRAINT_FUNCTION = 150;
        this.module.setValue(pxFunc, this.module.addFunction((ctx, argc, argv) => {
            // always return true since we apply this filter in the xFilter function
            this.module.set_return_value(ctx, true);
        }, "viii"), "i32");
        return SQLITE_INDEX_CONSTRAINT_FUNCTION;
    }
}
exports.SeriesVtab = SeriesVtab;
